import _ from 'lodash';
import {connect} from 'react-redux';

import {KnowledgeBaseErrorBannerState} from '../../../../../libs/knowledge-base/store/src/panel/banners/knowledgeBaseErrorBannerState';
import {KnowledgeBaseInfoBannerState} from '../../../../../libs/knowledge-base/store/src/panel/banners/knowledgeBaseInfoBannerState';
import {KnowledgeBaseSuccessBannerState} from '../../../../../libs/knowledge-base/store/src/panel/banners/knowledgeBaseSuccessBannersState';
import {KnowledgeBaseBanners} from '../../../../../libs/knowledge-base/web/src/components/banners/knowledgeBaseBanners';
import {BannerTypesEnum} from '../../../../../libs/shared/core/src/store/banners/commonBannerState';
import {
  ErrorBannerTypesEnum,
  InfoBannerTypesEnum,
  SuccessBannerTypesEnum,
} from '../../../../../libs/shared/core/src/store/banners/commonBannerTypes';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  AppParametricSelector,
  createShallowEqualSelector,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {makeGetVisibleBannersForPanel} from '../../../../store/panels/app/banners/bannersSelectors';

/*
 * Props.
 */

interface KnowledgeBaseBannersContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

type KnowledgeBaseSuccessBannersSelector = AppParametricSelector<
  KnowledgeBaseBannersContainerProps,
  ReadonlyArray<KnowledgeBaseSuccessBannerState>
>;

function makeGetKnowledgeBaseSuccessBanners(): KnowledgeBaseSuccessBannersSelector {
  return createShallowEqualSelector([makeGetVisibleBannersForPanel()], (visibleBanners) =>
    _(visibleBanners)
      .map((banner) => {
        if (
          banner.type === BannerTypesEnum.SUCCESS &&
          banner.successType === SuccessBannerTypesEnum.KNOWLEDGE_BASE
        ) {
          return banner;
        }

        return undefined;
      })
      .compact()
      .value(),
  );
}

type KnowledgeBaseErrorBannersSelector = AppParametricSelector<
  KnowledgeBaseBannersContainerProps,
  ReadonlyArray<KnowledgeBaseErrorBannerState>
>;

function makeGetKnowledgeBaseErrorBanners(): KnowledgeBaseErrorBannersSelector {
  return createShallowEqualSelector([makeGetVisibleBannersForPanel()], (visibleBanners) =>
    _(visibleBanners)
      .map((banner) => {
        if (
          banner.type === BannerTypesEnum.ERROR &&
          banner.errorType === ErrorBannerTypesEnum.KNOWLEDGE_BASE
        ) {
          return banner;
        }

        return undefined;
      })
      .compact()
      .value(),
  );
}

type KnowledgeBaseInfoBannersSelector = AppParametricSelector<
  KnowledgeBaseBannersContainerProps,
  ReadonlyArray<KnowledgeBaseInfoBannerState>
>;

function makeGetKnowledgeBaseInfoBanners(): KnowledgeBaseInfoBannersSelector {
  return createShallowEqualSelector([makeGetVisibleBannersForPanel()], (visibleBanners) =>
    _(visibleBanners)
      .map((banner) => {
        if (banner.type === BannerTypesEnum.INFO && banner.infoType === InfoBannerTypesEnum.KNOWLEDGE_BASE) {
          return banner;
        }

        return undefined;
      })
      .compact()
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<KnowledgeBaseBannersContainerProps>()(() => ({
  successBanners: makeGetKnowledgeBaseSuccessBanners(),
  errorBanners: makeGetKnowledgeBaseErrorBanners(),
  infoBanners: makeGetKnowledgeBaseInfoBanners(),
}));

export const KnowledgeBaseBannersContainer = connect(mapStateToProps)(KnowledgeBaseBanners);
